"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataWidgetGroup = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var helpers_1 = __importDefault(require("../common/helpers"));
var GKDataWidget_1 = __importDefault(require("../GKDataWidget/GKDataWidget"));
/**
 * Grouping of DataWidgets with default styling and layout rendered from a list of widget definitions.
 */
var GKDataWidgetGroup = function (props) {
    var persistentId = (0, common_1.usePersistentId2)(props.id);
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-data-widget-group",
        id: persistentId,
    }), _b = _a.cols, cols = _b === void 0 ? 2 : _b, data = _a.data, _c = _a.headingTag, headingTag = _c === void 0 ? "h5" : _c, headingText = _a.headingText, mergedProps = __rest(_a, ["cols", "data", "headingTag", "headingText"]);
    var qaBase = mergedProps["data-qa"];
    var heading = headingText &&
        React.createElement(headingTag, { className: "h5 my-4", "data-qa": qaBase + "--heading" }, headingText);
    var widgets = data.map(function (widget, i) {
        var itemId = persistentId + "-" + i;
        return (React.createElement(GKDataWidget_1.default, __assign({ className: "col", key: itemId }, widget, { id: widget.id || itemId, "data-qa": widget["data-qa"] || qaBase + "--widget" })));
    });
    return (React.createElement("div", __assign({}, mergedProps),
        heading,
        React.createElement("div", { "data-qa": qaBase + "--widget-container", className: helpers_1.default.getColumnClass(cols) }, widgets)));
};
exports.GKDataWidgetGroup = GKDataWidgetGroup;
exports.default = exports.GKDataWidgetGroup;
